import EtaSharing from './EtaSharing';

export default EtaSharing;